var map = {
	"./about-img.png": "d6d8",
	"./banner.jpg": "301c",
	"./blog-img.png": "b6af",
	"./blog_details.png": "e1a0",
	"./bongalo-logo-white.png": "388e",
	"./bongalo-logo.png": "ffaa",
	"./bongalo_fav_new.svg": "a016",
	"./bongalo_left_icon.png": "105b",
	"./careers_img.png": "3e4b",
	"./event1.png": "44e2",
	"./event2.png": "32e1",
	"./event3.png": "f75f",
	"./event4.png": "81d9",
	"./exp1.png": "0513",
	"./exp2.png": "e1af",
	"./exp3.png": "6979",
	"./exp4.png": "6fe9",
	"./footer-logo.png": "8bef",
	"./google.png": "bf83",
	"./house1.png": "209c",
	"./house2.png": "3908",
	"./house3.png": "2405",
	"./house4.png": "89a8",
	"./house5.png": "4ee0",
	"./house6.png": "b32d",
	"./house7.png": "9c49",
	"./house8.jpg": "e574",
	"./human-icon.png": "0dee",
	"./ibm_cloud.png": "a343",
	"./item1.png": "d7ad",
	"./item2.png": "a7f1",
	"./item3.png": "eb58",
	"./jumbotron-bg.png": "f045",
	"./map_placeholder.png": "bd47",
	"./middle-banner.png": "7bfe",
	"./mtn.png": "304f",
	"./no-image.webp": "3b57",
	"./no-image2.png": "0f8e",
	"./p-post.png": "a59e",
	"./pay1.png": "ddbd",
	"./pay2.png": "0851",
	"./pay3.png": "9eaf",
	"./pay4.png": "62f9",
	"./pic.png": "3108",
	"./powered1.1.png": "1860",
	"./powered1.png": "e24e",
	"./powered2.1.png": "7f0f",
	"./powered2.png": "4f8b",
	"./powered3.png": "f729",
	"./powered4.png": "35a5",
	"./powered5.1.1.jpg": "f210",
	"./powered5.png": "327d",
	"./s-icon.png": "ec39",
	"./uok.png": "e47a",
	"./user1.png": "b4ee",
	"./v-icon.png": "8cf2",
	"./vector.png": "e3fb",
	"./why1.png": "f2d1",
	"./why2.png": "bdbb",
	"./why3.png": "ae21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";